<template>
  <!-- 영역 6: Anomaly 타임라인 — REQ-FE-DETAIL-009 -->
  <!-- anomalyTimeline 빈 배열이면 미렌더 (REQ-FE-DETAIL-009: When empty, not rendered) -->
  <a-card
    v-if="anomalyTimeline && anomalyTimeline.length > 0"
    class="anomaly-timeline-panel"
    :title="$t('lotFlow_detail_anomalyTimeline_title')"
    style="margin-top: 16px;"
    data-testid="anomaly-timeline-panel"
  >
    <a-timeline>
      <a-timeline-item
        v-for="(item, idx) in anomalyTimeline"
        :key="idx"
        :color="severityColor(item.severity)"
        :data-testid="`anomaly-timeline-item-${item.type}`"
      >
        <div class="timeline-item-content">
          <div class="timeline-item-header">
            <strong>{{ $t('lotFlow_detail_anomalyTimeline_type_' + item.type) }}</strong>
            <a-tag
              :color="severityTagColor(item.severity)"
              style="margin-left: 8px; font-size: 11px;"
            >{{ item.severity }}</a-tag>
          </div>
          <div class="timeline-item-time" v-if="item.occurredAt">
            {{ formatDate(item.occurredAt) }}
          </div>
          <div class="timeline-item-time text-muted" v-else>—</div>
          <div v-if="item.message" class="timeline-item-message">{{ item.message }}</div>
        </div>
      </a-timeline-item>
    </a-timeline>
  </a-card>
</template>

<script>
export default {
  name: 'AnomalyTimelinePanel',
  props: {
    anomalyTimeline: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // severity → Ant Design Timeline color
    severityColor(severity) {
      if (severity === 'error') return 'red';
      if (severity === 'warning') return 'orange';
      if (severity === 'info') return 'blue';
      return 'gray';
    },
    severityTagColor(severity) {
      if (severity === 'error') return 'error';
      if (severity === 'warning') return 'warning';
      if (severity === 'info') return 'processing';
      return 'default';
    },
    formatDate(val) {
      if (!val) return '-';
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString('zh-CN', { timeZone: 'Asia/Shanghai' });
    },
  },
};
</script>

<style scoped>
.timeline-item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.timeline-item-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.timeline-item-time {
  font-size: 12px;
  color: #595959;
}
.text-muted {
  color: #bfbfbf;
}
.timeline-item-message {
  font-size: 12px;
  color: #8c8c8c;
  word-break: break-word;
}
</style>
